import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../State/Store";

import { AddPhotoAlternate, Close } from "@mui/icons-material";
import { createDeal } from "../../../State/admin/DealSlice";
import { useNavigate } from "react-router-dom";
import { uploadImageToCloudinary } from "../../../State/seller/sellerUploadToCloudinary";
import { categoryThree } from "../../../customer/data/Filter/categoryFilter";

export const CreateDealForm = ({setActiveTab}:{setActiveTab:React.Dispatch<React.SetStateAction<string>>}) => {
  const navigate = useNavigate()
  const [uploadImage, setUploadImage] = useState(false);
  const dispatch = useAppDispatch();
  const {deal} = useAppSelector(store=>store)
  const { homeCategory } = useAppSelector((store) => store);
  const formik = useFormik({
    initialValues: {
      discount: 0,
      categoryId: "",
      image: "",
      name: "",
    
    },
    onSubmit: async (values) => {
     
      await dispatch(createDeal(values));
      
    },
  });
  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    try {
      setUploadImage(true);
      const url = await dispatch(uploadImageToCloudinary(file)).unwrap();
      formik.setFieldValue("image",  url);
    } catch (err) {
      console.error(err);
    } finally {
      setUploadImage(false);
    }
  };

  const handleRemoveImage = () => {
    // Remove the image at the specified index

    formik.setFieldValue("image", "");
  };
  useEffect(() => { 
    if(deal.dealCreated){
      setActiveTab("Deals")
    }
   },[deal.dealCreated])
  return (
    <Box
      component={"form"}
      onSubmit={formik.handleSubmit}
      className="space-y-3 "
    >
      <Typography variant="h4" className="text-center">
        Create Deal
      </Typography>

      <FormControl fullWidth>
        <Grid2 container spacing={2}>
          <Grid2 className="flex flex-wrap gap-7" size={{ xs: 12 }}>
            {/* Hidden File Input */}
            <input
              type="file"
              accept="image/*"
              id="fileInput"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />

            {/* Custom Button for File Input */}
            <label htmlFor="fileInput" className="relative">
              <span className="w-24 h-24 cursor-pointer flex items-center justify-center border rounded-md">
                <AddPhotoAlternate className="text-gray-700" />
              </span>
              {/* Show Circular Progress if Uploading */}
              {uploadImage && (
                <div className="absolute left-0 right-0 top-0 bottom-0 w-24 h-24 flex items-center justify-center">
                  <CircularProgress />
                </div>
              )}
            </label>
          {formik.values.image &&   <div className="flex flex-wrap gap-2">
              <div className="relative">
                {/* Render the uploaded image */}
                <img
                  className="w-24 h-24 object-cover"
                  src={formik.values.image}
                />

                {/* Render the delete button */}
                <IconButton
                  onClick={() => handleRemoveImage()}
                  className=""
                  size="small"
                  color="error"
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    outline: "none",
                  }}
                >
                  <Close />
                </IconButton>
              </div>
            </div>}
          </Grid2>
          <Grid2 size={{ xs: 12}}>
            <TextField
              fullWidth
              name="discount"
              label="Discount"
              value={formik.values.discount}
              onChange={formik.handleChange}
              error={formik.touched.discount && Boolean(formik.errors.discount)}
              helperText={formik.touched.discount && formik.errors.discount}
            />
          </Grid2>

          <Grid2 size={{ xs: 12}}>
            <TextField
              fullWidth
              name="name"
              label="Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid2>

          <Grid2 size={{ xs: 12}}>
            <FormControl
              fullWidth
              error={formik.touched.categoryId && Boolean(formik.errors.categoryId)}
              required
            >
              <InputLabel id="categoryId-label">Category</InputLabel>
              <Select
                labelId="categoryId-label"
                id="categoryId"
                name="categoryId"
                value={formik.values.categoryId}
                onChange={formik.handleChange}
                label="CategoryId"
              >
                { 
                  Object.values(categoryThree).map((categoryArray) =>
                    categoryArray.map((item) => (
                        <MenuItem key={item.categoryId} value={item.categoryId}>
                            {item.name}
                        </MenuItem>
                    ))
                )}
              </Select>
              {formik.touched.categoryId && formik.errors.categoryId && (
                <FormHelperText>{formik.errors.categoryId}</FormHelperText>
              )}
            </FormControl>
          </Grid2>
       <Grid2  size={{ xs: 12}}>
       <Button
          fullWidth
          sx={{ py: ".9rem" }}
          type="submit"
          variant="contained"
        >
          Create Deal
        </Button>
       </Grid2>
         
        </Grid2>

      </FormControl>
    </Box>
  );
};
